// src/services/api/refreshTokenManager.ts

import { refreshAccessToken } from '@/domains/auth/utils/refreshAccessToken';

let refreshPromise: Promise<string> | null = null;

export const getRefreshTokenOnce = (): Promise<string> => {
  if (!refreshPromise) {
    refreshPromise = refreshAccessToken().finally(() => {
      refreshPromise = null;
    });
  }

  return refreshPromise;
};
